import { cn as e } from "../../../utils/utils.mjs";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
import { Slot as r } from "@radix-ui/react-slot";
import { cva as i } from "class-variance-authority";
//#region src/components/atoms/Text/Text.tsx
var a = i("", {
	variants: {
		fontFamily: {
			inter: "font-inter",
			polysans: "font-polysans"
		},
		fontSize: {
			"5xl": "text-5xl-mobile leading-[var(--text-5xl--line-height-mobile)] md:text-5xl-tablet md:leading-[var(--text-5xl--line-height-tablet)] lg:text-5xl lg:leading-[var(--text-5xl--line-height)]",
			"4xl": " text-4xl-mobile leading-[var(--text-4xl--line-height-mobile)] md:text-4xl-tablet md:leading-[var(--text-4xl--line-height-tablet)] lg:text-4xl lg:leading-[var(--text-4xl--line-height)]",
			"3xl": "text-3xl-mobile leading-[var(--text-3xl--line-height-mobile)] md:text-3xl-tablet md:leading-[var(--text-3xl--line-height-tablet)] lg:text-3xl lg:leading-[var(--text-3xl--line-height)]",
			"2xl": " text-2xl-mobile leading-[var(--text-2xl--line-height-mobile)] md:text-2xl-tablet md:leading-[var(--text-2xl--line-height-tablet)] lg:text-2xl lg:leading-[var(--text-2xl--line-height)]",
			xl: "text-xl-mobile leading-[var(--text-xl--line-height-mobile)] md:text-xl-tablet md:leading-[var(--text-xl--line-height-tablet)] lg:text-xl lg:leading-[var(--text-xl--line-height)]",
			lg: "text-lg-mobile leading-[var(--text-lg--line-height-mobile)] md:text-lg-tablet md:leading-[var(--text-lg--line-height-tablet)] lg:text-lg lg:leading-[var(--text-lg--line-height)]",
			base: "text-base-mobile leading-[var(--text-base--line-height-mobile)] md:text-base-tablet md:leading-[var(--text-base--line-height-tablet)] lg:text-base lg:leading-[var(--text-base--line-height)]",
			sm: "text-sm-mobile leading-[var(--text-sm--line-height-mobile)] md:text-sm-tablet md:leading-[var(--text-sm--line-height-tablet)] lg:text-sm lg:leading-[var(--text-sm--line-height)]",
			xs: "text-xs-mobile leading-[var(--text-xs--line-height-mobile)] md:text-xs-tablet md:leading-[var(--text-xs--line-height-tablet)] lg:text-xs lg:leading-[var(--text-xs--line-height)]"
		},
		fontWeight: {
			regular: "",
			semibold: "font-semibold",
			bold: ""
		}
	},
	compoundVariants: [{
		fontFamily: "inter",
		fontSize: [
			"lg",
			"base",
			"sm",
			"xs"
		],
		fontWeight: "bold",
		class: "font-bold"
	}, {
		fontFamily: ["inter", "polysans"],
		fontSize: [
			"2xl",
			"xl",
			"lg",
			"base",
			"sm",
			"xs"
		],
		fontWeight: "regular",
		class: "font-normal"
	}],
	defaultVariants: {
		fontFamily: "inter",
		fontSize: "base",
		fontWeight: "semibold"
	}
}), o = t(({ className: t, children: i, asChild: o = !1, fontWeight: s = "semibold", fontSize: c = "base", fontFamily: l = "inter", ...u }, d) => /* @__PURE__ */ n(o ? r : "p", {
	ref: d,
	className: e(a({
		fontFamily: l,
		fontSize: c,
		fontWeight: s,
		className: t
	})),
	...u,
	children: i
}));
o.displayName = "Text";
//#endregion
export { o as Text };
